import { Action } from '@ngrx/store';
import { File } from '../../../vas/business-objects/file/file.model';
import { Report } from '../../../vas/business-objects/report/report.model';

export const LOAD = '[EmailAttachmentPicker] Load';
export const LOAD_FAIL = '[EmailAttachmentPicker] Load Fail';
export const LOAD_SUCCESS = '[EmailAttachmentPicker] Load Success';
export const SET_SELECTED_FILES = '[EmailAttachmentPicker] Set Selected Files';
export const SET_SELECTED_REPORTS = '[EmailAttachmentPicker] Set Selected Reports';
export const TOGGLE_ALL_FILES = '[EmailAttachmentPicker] Select All Files';
export const TOGGLE_ALL_REPORTS = '[EmailAttachmentPicker] Select All Reports';
export const TOGGLE_FILE = '[EmailAttachmentPicker] Toggle File';
export const TOGGLE_REPORT = '[EmailAttachmentPicker] Toggle Report';

export class ActionLoad implements Action {
    readonly type = LOAD;

    constructor(public payload: {accountId: string, jobId: string}) {

    }
}

export class ActionLoadFail implements Action {
    readonly type = LOAD_FAIL;

    constructor(public payload: Error) {
    }
}

export class ActionLoadSuccess implements Action {
    readonly type = LOAD_SUCCESS;

    constructor(public payload: {reports: Array<Report>, files: Array<File>}) {
    }
}

export class ActionSetSelectedFiles implements Action {
    readonly type = SET_SELECTED_FILES;

    constructor(public payload: Array<string>) {
    }
}
export class ActionSetSelectedReports implements Action {
    readonly type = SET_SELECTED_REPORTS;

    constructor(public payload: Array<string>) {
    }
}

export class ActionToggleAllFiles implements Action {
    readonly type = TOGGLE_ALL_FILES;

    constructor(public payload: boolean) {

    }
}

export class ActionToggleAllReports implements Action {
    readonly type = TOGGLE_ALL_REPORTS;

    constructor(public payload: boolean) {

    }
}

export class ActionToggleFile implements Action {
    readonly type = TOGGLE_FILE;

    constructor(public payload: {file: File, selected: boolean}) {
    }
}

export class ActionToggleReport implements Action {
    readonly type = TOGGLE_REPORT;

    constructor(public payload: {report: Report, selected: boolean}) {
    }
}

export declare type Actions
    = ActionLoad
    | ActionLoadFail
    | ActionLoadSuccess
    | ActionSetSelectedFiles
    | ActionSetSelectedReports
    | ActionToggleAllFiles
    | ActionToggleAllReports
    | ActionToggleFile
    | ActionToggleReport;



// WEBPACK FOOTER //
// ./src/app/modals-popovers/email-attachment-picker-modal/email-attachment-picker-modal.actions.ts